<template>
<Dialog v-model="visible" :width="1280" setting @setting="$emit('setting')">

  <template slot="title">
    <span class="title">{{ $t(`type.TEMPERATURE`) }}</span>
  </template>

  <template slot="menu">
    <TemperatureUnitSelector></TemperatureUnitSelector>
    <HistoryRangeSelector v-model="dataType"></HistoryRangeSelector>
  </template>

  <LineChart :data="data" :options="options"></LineChart>

</Dialog>
</template>

<script>
import Dialog from '@/components/utils/dialog/Dialog'
import LineChart from '@/components/chart/LineChart'
import DataChartDialog from '@/components/chart/DataChartDialog'
import TemperatureUnitSelector from '@/components/utils/TemperatureUnitSelector'
import HistoryRangeSelector from '@/components/utils/HistoryRangeSelector'

export default {
  name: 'TemperatureChartDialog',
  mixins: [DataChartDialog],
  components: {
    Dialog,
    LineChart,
    TemperatureUnitSelector,
    HistoryRangeSelector
  },
  props: {
    reportUnit: {
      type: String
    },
    desiredUnit: {
      type: String
    }
  },
  computed: {
    data() {
      return {
        datasets: [{
          data: this.itemKeys.map(t => ({
            t: parseInt(t),
            y: this.transformByUnit((this.rawData[t] || {}).temperature)
          })),
          borderWidth: 1.5,
          lineTension: 0,
          pointRadius: 0.5,
          fill: false,
          borderColor: this.$vuetify.theme.currentTheme.primary,
          backgroundColor: this.$vuetify.theme.currentTheme.primary
        }]
      };
    },
    options() {
      return {
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              max: this.timestamp
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: 0,
              suggestedMin: this.unitMinimum,
              suggestedMax: this.unitMaximum
            },
            scaleLabel: {
              display: !!this.unit,
              labelString: this.unit
            }
          }]
        },
        tooltips: {
          intersect: false,
          mode: 'index',
          axis: 'x'
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: false
      };
    },
    unitMinimum() {
      return this.reportUnit == 'C' ? 0 : 32;
    },
    unitMaximum() {
      return this.reportUnit == 'C' ? 45 : 120;
    }
  },
  methods: {
    transformByUnit(value) {
      if (value == undefined) return null;
      if (this.reportUnit == 'C' && this.desiredUnit == 'F') return value * 9 / 5 + 32;
      if (this.reportUnit == 'F' && this.desiredUnit == 'C') return (value - 32) * 5 / 9;
      return value;
    }
  }
}
</script>
